var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72561 13.9999C3.42558 12.5826 -0.905931 8.66634 0.168244 4.3398C0.541222 2.79816 2.36881 -0.225443 6.69535 0.013263C8.29916 0.212187 11.7978 1.61707 11.8797 5.38415C11.917 7.09984 11.4322 10.2329 5.72561 13.9999ZM5.83756 8.47992C7.30008 8.47992 8.4857 7.29431 8.4857 5.83178C8.4857 4.36925 7.30008 3.18364 5.83756 3.18364C4.37503 3.18364 3.18942 4.36925 3.18942 5.83178C3.18942 7.29431 4.37503 8.47992 5.83756 8.47992Z",
    fill: "#F46767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneLocationIcon);
export default __webpack_public_path__ + "static/media/zone-location-icon.e4177e55f5a06a6ff186b998be88bc1c.svg";
export { ForwardRef as ReactComponent };